const SectionInfoTypeToFormFieldType = {
    'TextInput': 'STRING', // eslint-disable-line quote-props
    'Email': 'STRING', // eslint-disable-line quote-props
    'Choice': 'SELECT', // eslint-disable-line quote-props
    'Relationship': 'RELATIONSHIP', // eslint-disable-line quote-props
    'TextArea': 'TEXT_AREA' // eslint-disable-line quote-props
};

export default SectionInfoTypeToFormFieldType;
